module.exports = __webpack_public_path__ + "static/am_capabilities_5-99a995b117476a7d91db02f4df571faf.png";